var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 294 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3{stroke-width:0px;}.cls-3{fill:#ffc400;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40,
    y: 25.91,
    width: 217,
    height: 247.14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    className: "cls-3",
    d: "M111.27,273.05c-3.37-.86-6.79-1.48-10.25-1.88-41.26-8.4-67.9-48.66-59.5-89.92,6.26-30.75,30.72-54.52,61.63-59.9,7.53-1.32,15.21-1.61,22.83-.87,2.07.2,3.11.65,3.07,3.24-.2,11.83-.12,23.66-.06,35.49,0,1.92-.08,2.61-2.44,2-19.49-5.05-39.38,6.65-44.44,26.14-5.05,19.49,6.65,39.38,26.14,44.44,19.49,5.05,39.38-6.65,44.44-26.14.61-2.37.99-4.8,1.12-7.24.42-12.06.22-24.14.23-36.21V28.68c0-2.19.53-2.81,2.76-2.81,11.83.12,23.66.09,35.49,0,1.69,0,2.09.47,2.16,2.12,1.34,32.49,27.48,58.47,59.97,59.62,1.88.07,2.6.45,2.58,2.52-.11,11.83-.11,23.66,0,35.49,0,1.88-.51,2.24-2.3,2.19-21.21-.4-41.76-7.42-58.77-20.08-.33-.23-.66-.46-.99-.68-.17-.05-.35-.08-.53-.08v2.51c.08,28.57.17,57.13.25,85.71.3,13.91-3.33,27.61-10.49,39.54-12.66,21.87-35.34,36.04-60.55,37.84-.43,0-.99-.2-1.19.47h-2.42c-1.52-.76-3.31-.76-4.83,0l-3.89.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    className: "cls-3",
    d: "M115.17,273.06c1.52-.76,3.31-.76,4.83,0h-4.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.8376ba978a5a6c836ce1cde5bece7bbd.svg";
export { ForwardRef as ReactComponent };